/* eslint-disable one-var */
let _ = require('lodash')
let _moment = require('moment')
import getSecret from '@utils/get-secret'

export default {
  install(Vue) {
    // 1. add global method or property
    Vue.prototype.$generate_noty = (notyType, text, duration, group) => {
      
      let opt = {
        group: group || 'foo', // default group
        duration: duration || 5000, // duration of the notify
        text: text,
      }
      let variant = 'info'
      if (notyType === 'error') {
        variant = 'danger'
        opt['type'] = 'error'
        opt['title'] = 'Error'
      } else if (notyType === 'success') {
        variant = 'success'
        opt['type'] = 'success'
        opt['title'] = 'Exitoso'
      } else if (notyType === 'warn') {
        variant = 'warning'
        opt['type'] = 'warn'
        opt['title'] = 'Alerta'
      } else {
        opt['title'] = 'Información'
      }
      //Vue.prototype.$notify(opt)
      Vue.prototype.$swal({
        title: opt['title'],
        html: text,
        confirmButtonText: 'Aceptar',
        showCloseButton: true,
        width: '660px',
        position: 'top',
        customClass: {
          title: 'text-'+ variant,
          confirmButton: 'btn btn-primary rounded-pill',
          cancelButton: 'btn btn-default rounded-pill'
        },
        showClass: {
          backdrop: 'swal2-backdrop-show swal2-backdrop-'+ variant,
        },
     });
    }

    Vue.prototype.$generate_toast = (
      vm,
      notyType,
      text,
      title,
      duration,
      toaster
    ) => {
      let opt = {
        toaster: toaster || 'b-toaster-top-right', // default toaster
        autoHideDelay: duration || 5000, // duration of the notify
        solid: true,
      }
      let variant = 'info'
      if (notyType === 'error') {
        variant = 'danger'
        opt['type'] = 'error'
        opt['title'] = 'Error'
      } else if (notyType === 'success') {
        variant = 'success'
        opt['type'] = 'success'
        opt['title'] = 'Exitoso'
      } else if (notyType === 'warn') {
        variant = 'warning'
        opt['type'] = 'warn'
        opt['title'] = 'Alerta'
      } else {
        opt['title'] = 'Información'
      }
      // vm.$bvToast.toast(text, opt)

      Vue.prototype.$swal({
        title: opt['title'],
        text: text,
        confirmButtonText: 'Aceptar',
        showCloseButton: true,
        width: '660px',
        position: 'top',
        customClass: {
          title: 'text-'+ variant,
          confirmButton: 'btn btn-primary rounded-pill',
          cancelButton: 'btn btn-default rounded-pill'
        },
        showClass: {
          backdrop: 'swal2-backdrop-show swal2-backdrop-'+ variant,
        },
     });

    }
    Vue.prototype.$axios_error_noty = (e, vm) => {
      // Receives an axios catched error
      if (e.response) {
        if (e.response.status === 403 && 'data' in e.response) {
          if (vm) {
            Vue.prototype.$generate_toast(vm, 'error', e.response.data.detail)
          } else {
            Vue.prototype.$generate_noty('error', e.response.data.detail)
          }
        } else if (e.response.status === 404 && 'data' in e.response) {
          if (vm) {
            Vue.prototype.$generate_toast(
              vm,
              'error',
              `Error 404, ${e.response.data.detail}`
            )
          } else {
            Vue.prototype.$generate_noty(
              'error',
              `Error 404, ${e.response.data.detail}`
            )
          }
        } else if (e.response.status === 400 && 'data' in e.response) {
          Object.keys(e.response.data).forEach((key) => {
            if (vm) {
              Vue.prototype.$generate_toast(
                vm,
                'error',
                e.response.data[key],
                _.startCase(key)
              )
            } else {
              Vue.prototype.$generate_noty(
                'error',
                `<b>${_.startCase(key)}</b><br/>${e.response.data[key]}`
              )
            }
          })
        } else if (e.response.status === 401) {
          if (vm) {
            vm.$router.push({
              name: 'logout',
              params: { expiredSession: true },
            })
          } else {
            Vue.prototype.$generate_noty(
              'error',
              'Your session has expired, please log in again'
            )
          }
        } else if (e.response.status === 500) {
          if (vm) {
            Vue.prototype.$generate_toast(vm, 'error', 'Internal server error')
          } else {
            Vue.prototype.$generate_noty('error', 'Internal server error')
          }
        }
      } else {
        if (vm) {
          Vue.prototype.$generate_toast(vm, 'error', e.message)
        } else {
          Vue.prototype.$generate_noty('error', e.message)
        }
      }
    }

    Vue.prototype.$table_params = (ctx) => {
      // console.log("ctx:", ctx)
      /* Receive a vue datatable filters: 
                {
                    apiUrl: ""
                    currentPage: 1
                    filter: null
                    perPage: 0
                    sortBy: ""
                    sortDesc: false
                }
            */
      let query = ''
      if (ctx.hasOwnProperty('filterset') && ctx.filterset) {
        query = query ? query + `&${ctx.filterset}` : `${ctx.filterset}`
      }
      if (ctx.hasOwnProperty('filter') && ctx.filter) {
        if (ctx.filter.length >= 3){
          query = query
            ? query + `&search=${ctx.filter}`
            : query + `search=${ctx.filter}`
        }
      }
      if (ctx.hasOwnProperty('perPage') && ctx.perPage) {
        query = query
          ? query + `&page_size=${ctx.perPage}`
          : query + `page_size=${ctx.perPage}`
      }
      if (ctx.hasOwnProperty('currentPage') && ctx.currentPage) {
        query = query
          ? query + `&page=${ctx.currentPage}`
          : query + `page=${ctx.currentPage}`
      }
      if (ctx.hasOwnProperty('sortBy') && ctx.sortBy) {
        if (ctx.hasOwnProperty('sortDesc') && ctx.sortDesc) {
          query = query
            ? query + `&ordering=${ctx.sortBy}`
            : query + `ordering=${ctx.sortBy}`
        } else {
          query = query
            ? query + `&ordering=-${ctx.sortBy}`
            : query + `ordering=-${ctx.sortBy}`
        }
      }
      let apiurl=(ctx.apiUrl ? ctx.apiUrl : '') 
      return query ? `${apiurl}?${query}` : query
    }

    Vue.prototype.$select_params = (searchQuery) => {
      /* Receive a vue multiselect query filter: */
      let query = '?page_size=200'
      return searchQuery ? `${query}&search=${searchQuery}` : query
    }

    Vue.prototype.$syllabify = (word) => {
      // Test it: console.log(['away', 'hair', 'halter', 'hairspray', 'father', 'lady', 'kid'].map(syllabify))
      // Return an array with each sillable
      const syllableRegex = /[^aeiouy]*[aeiouy]+(?:[^aeiouy]*$|[^aeiouy](?=[^aeiouy]))?/gi
      return word.match(syllableRegex)
    }

    Vue.prototype.$truncateWords = (word, n) => {
      return word.substr(0, n - 1) + (word.length > n ? '...' : '')
    }

    Vue.prototype.$thousandSeparated = (x, separatorChar) => {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separatorChar)
    }

    Vue.prototype.$arraySuffle = (array) => {
      let currentIndex = array.length,
        temporaryValue,
        randomIndex

      // While there remain elements to shuffle...
      while (currentIndex !== 0) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex)
        currentIndex -= 1

        // And swap it with the current element.
        temporaryValue = array[currentIndex]
        array[currentIndex] = array[randomIndex]
        array[randomIndex] = temporaryValue
      }

      return array
    }
    Vue.prototype.$getSecret = (key) => {
      return getSecret(key)
    }
    Vue.prototype.$removeSpecialChars = (stringToReplace) => {
      return stringToReplace.replace(/[^\w\s]/gi, '')
    }
    Vue.prototype.$cleanPhoneNumber = (stringToReplace) => {
      return `+${stringToReplace.replace(/[^\w\s]/gi, '')}`.replace(' ', '')
    }
    Vue.prototype.$uuidv4 = () => {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(
        c
      ) {
        let r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
      })
    }

    Vue.prototype.$strfDatetime = (datetime = new Date()) => {
      return _moment(datetime).format('YYYY-MM-DD hh:mm:ss a')
    }

    Vue.prototype.$datetimesDiff = (datetime1, datetime2) => {
      let date1 = _moment(datetime1)
      let date2 = _moment(datetime2)
      return date2.diff(date1)
    }
  },
}
